import { Component } from '@angular/core';

@Component({
  selector: 'consultation-ordered-modal',
  templateUrl: './consultation-ordered-modal.component.html',
  styleUrls: ['./consultation-ordered-modal.component.scss'],
})
export class ConsultationOrderedModalComponent {}
